var React = require('react');

function Phone (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.012 1c.16 0 .318.013.473.037l.007.002.047.007.06.01.037.008c.313.073.574.3.693.6l1.223 3.545a.797.797 0 01-.099.383l.177.495c0 .002 0 .005-.002.006h0l-1.283.845a.495.495 0 00-.197.25l-.07-.153c.783 1.758 2.15 3.143 3.849 3.9l.323.145c.002 0 .005 0 .007-.002l.88-1.293a.788.788 0 01.904-.296l3.263 1.17a.996.996 0 01.651.812l.004.025A3.016 3.016 0 0111.988 15c-4.932 0-9.15-3.31-10.493-7.885C1.153 5.95 1 5 1 4.012A3.016 3.016 0 014.012 1z","stroke":"currentColor","strokeWidth":"1.2","fill":"none"}));
}

Phone.defaultProps = {"viewBox":"0 0 16 16","width":"16","height":"16"};

module.exports = Phone;

Phone.default = Phone;
